import { render, staticRenderFns } from "./EditAvatar.vue?vue&type=template&id=ce86bcea&scoped=true"
import script from "./EditAvatar.vue?vue&type=script&lang=js"
export * from "./EditAvatar.vue?vue&type=script&lang=js"
import style0 from "./EditAvatar.vue?vue&type=style&index=0&id=ce86bcea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce86bcea",
  null
  
)

export default component.exports